import './styles.scss'

import React from 'react'
import naturalCompare from 'string-natural-compare'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import MobilePopularCities from '~/scenes/homepage/popular-cities/mobile-popular-cities'
import DesktopPopularCities from '~/scenes/homepage/popular-cities/desktop-popular-cities'

import logic from '../logic'

export default function PopularCities () {
  const { popularCities, smallScreen, mediumScreen, largeScreen } = useValues(logic)

  let cnt = 0
  let cities = [...popularCities].sort((a, b) => b.count - a.count)
  cities = cities.map(c => Object.assign({}, c, { group: Math.floor(cnt++ / 15) }))
  cities.sort((a, b) => naturalCompare.caseInsensitive(a.url, b.url))

  return (
    <div id='homepage-popular-cities'>
      <div className='grid'>
        <div className='col-1-1'>
          <h2 className='homepage'>{I18n.t('react.homepage.cities.title')}</h2>
          {largeScreen && <DesktopPopularCities cities={cities} />}
          {(smallScreen || mediumScreen) && <MobilePopularCities cities={cities} />}
        </div>
      </div>
    </div>
  )
}
